// Matches com.medprompt.vector.file.EmailJoinType (JSON uses enum name)
export const EMAIL_JOIN_DEFAULT = 'EMAIL_AND_ATTACHMENT';
export const EMAIL_JOIN_TYPES = ['EMAIL_AND_ATTACHMENT', 'ATTACHMENT_ONLY'];
export const EMAIL_JOIN_LABELS = {
  EMAIL_AND_ATTACHMENT: 'Email & attachment',
  ATTACHMENT_ONLY: 'Attachment only',
};

// Matches com.medprompt.document.details.DocumentTypeField (JSON uses enum name)
export const DOCUMENT_TYPE_FIELD_DEFAULT = 'CLINICAL_DEPARTMENT';
export const DOCUMENT_TYPE_FIELDS = ['CLINICAL_DEPARTMENT', 'LETTER_TYPE'];
export const DOCUMENT_TYPE_FIELD_LABELS = {
  CLINICAL_DEPARTMENT: 'Clinical department',
  LETTER_TYPE: 'Letter type',
};

export const GUIDANCE_CONTENT_TYPES = [
  {
    key: 'LETTER_TYPE_STATUS',
    label: 'Letter type',
    description: 'Extra instructions when classifying the document letter type.',
  },
  {
    key: 'CLINICAL_DEPARTMENT_STATUS',
    label: 'Clinical department',
    description: 'Extra instructions when classifying the authoring clinical department.',
  },
  {
    key: 'RISK_CATEGORY_STATUS',
    label: 'Urgency',
    description: 'Extra instructions when assigning HIGH, MEDIUM, or LOW urgency.',
  },
];
